import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FiltrosServicios from "../../componentesEspeciales/serviciosAdmin/filtrosServicios";
import ListaServicios from "../../componentesEspeciales/serviciosAdmin/listaServicios";

const FILTROS_VACIO = {
    falta1: false,
    paso1: false, paso2: false, paso3: false, paso4: false, paso5: false,
    sinWA: false, sinEmail: false, sinApp: false, sinTelefono: false,
    esDigital: false, esPresencial: false, esUrgente: false,
    categoria: "",
    ciudad: "",
};

const TABS = [
    { key: "Borrador",      icon: "bi-pencil-square",  label: "Borrador",      badgeCls: "bg-primary" },
    { key: "Revision",      icon: "bi-hourglass-split", label: "En revisión",  badgeCls: "bg-warning text-dark" },
    { key: "Aprobado",      icon: "bi-check-circle",   label: "Aprobado",      badgeCls: "bg-primary" },
    { key: "Desaprobado",   icon: "bi-x-circle",       label: "Desaprobado",   badgeCls: "bg-danger" },
    { key: "ErrorRevision", icon: "bi-exclamation-triangle", label: "Error revisión", badgeCls: "bg-danger" },
    { key: "Pausado",       icon: "bi-pause-circle",   label: "Pausado",       badgeCls: "bg-secondary" },
];

function Servicios() {
    const navigate = useNavigate();

    const [tab, setTab]         = useState("Borrador");
    const [pagina, setPagina]   = useState(1);
    const [servicios, setServicios] = useState([]);
    const [cargando, setCargando]   = useState(false);
    const [total, setTotal]     = useState(0);
    const [paginas, setPaginas] = useState(1);
    const [conteos, setConteos] = useState({});
    const [filtros, setFiltros] = useState({ ...FILTROS_VACIO });

    function cambiarTab(nuevoTab) {
        setTab(nuevoTab);
        setPagina(1);
        if (nuevoTab !== "Borrador") {
            setFiltros(f => ({ ...FILTROS_VACIO, esDigital: f.esDigital, esPresencial: f.esPresencial, esUrgente: f.esUrgente, categoria: f.categoria, ciudad: f.ciudad }));
        }
    }

    function cambiarFiltros(f) {
        setPagina(1);
        setFiltros(f);
    }

    function cambiarPagina(p) {
        setPagina(p);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }

    useEffect(() => {
        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/todos-los-servicios-admin", { params: {
                    estado: tab,
                    pagina,
                    categoria:    filtros.categoria    || undefined,
                    sinWA:        filtros.sinWA        || undefined,
                    sinEmail:     filtros.sinEmail      || undefined,
                    sinApp:       filtros.sinApp        || undefined,
                    sinTelefono:  filtros.sinTelefono   || undefined,
                    esDigital:    filtros.esDigital     || undefined,
                    esPresencial: filtros.esPresencial  || undefined,
                    esUrgente:    filtros.esUrgente     || undefined,
                    paso1:        filtros.paso1         || undefined,
                    paso2:        filtros.paso2         || undefined,
                    paso3:        filtros.paso3         || undefined,
                    paso4:        filtros.paso4         || undefined,
                    paso5:        filtros.paso5         || undefined,
                    falta1:       filtros.falta1        || undefined,
                    ciudad:       filtros.ciudad         || undefined,
                }});
                setServicios(res.data.servicios || []);
                setTotal(res.data.total || 0);
                setPaginas(res.data.paginas || 1);
                setConteos(res.data.conteos || {});
            } catch { setServicios([]); }
            finally { setCargando(false); }
        })();
    }, [
        tab, pagina,
        filtros.categoria, filtros.sinWA, filtros.sinEmail, filtros.sinApp, filtros.sinTelefono,
        filtros.esDigital, filtros.esPresencial, filtros.esUrgente,
        filtros.paso1, filtros.paso2, filtros.paso3, filtros.paso4, filtros.paso5, filtros.falta1, filtros.ciudad,
    ]);

    const totalGlobal = Object.values(conteos).reduce((a, b) => a + b, 0);

    return (
        <div className="container-fluid">
            <div className="pt-3 pb-2 mb-4 border-bottom">
                <h1 className="h2 text-dark mb-1">Servicios</h1>
                <p className="text-muted mb-0 small">
                    {totalGlobal > 0
                        ? `${totalGlobal.toLocaleString("es-CO")} servicios en total`
                        : "Cargando servicios..."}
                </p>
            </div>

            <div className="mb-3">
                <FiltrosServicios filtros={filtros} onChange={cambiarFiltros} tab={tab} />
            </div>

            <ul className="nav nav-tabs mb-4">
                {TABS.map(({ key, icon, label, badgeCls }) => (
                    <li className="nav-item" key={key}>
                        <button
                            className={`nav-link ${tab === key ? "active fw-semibold" : ""}`}
                            onClick={() => cambiarTab(key)}
                        >
                            <i className={`bi ${icon} me-1`}></i>{label}
                            {conteos[key] > 0 && (
                                <span className={`badge ${badgeCls} rounded-pill ms-2`} style={{ fontSize: "0.7rem" }}>
                                    {conteos[key]}
                                </span>
                            )}
                        </button>
                    </li>
                ))}
            </ul>

            <ListaServicios
                servicios={servicios}
                total={total}
                paginas={paginas}
                pagina={pagina}
                onCambiarPagina={cambiarPagina}
                onClickVer={s => navigate("/admin/servicio", { state: { params: { idServicio: s.idServicio } } })}
                cargando={cargando}
            />
        </div>
    );
}

export default Servicios;
